




























































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CardSliderArrowSvg extends Vue {
  @Prop({ type: String, default: '#8164a6' })
  public color!: string;

  @Prop({ type: Boolean, default: true })
  public isLeftArrow!: boolean;

  leftArrow: string = 'matrix(-1 0 0 -1 34 34)';
  rightArrow: string = 'translate(8 8)';

  get arrowIcon(): string {
    const { isLeftArrow, leftArrow, rightArrow } = this;
    return isLeftArrow ? leftArrow : rightArrow;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/slider/images/components/CardSliderArrowSvg.vue